import { forwardRef, type SVGProps } from 'react';

export type LocationsIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const LocationsIcon = forwardRef<SVGSVGElement, LocationsIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 32 32">
    <path
      d="M19.7275 22.2725C20.4805 22.2726 21.0907 22.9443 21.0908 23.7725C21.0908 24.6008 20.4805 25.2723 19.7275 25.2725H13.1816C12.4286 25.2724 11.8184 24.6008 11.8184 23.7725C11.8185 22.9442 12.4287 22.2726 13.1816 22.2725H19.7275ZM24.0908 14.6367C24.8439 14.6367 25.4541 15.3083 25.4541 16.1367C25.4539 16.965 24.8438 17.6367 24.0908 17.6367H8.81836C8.06535 17.6367 7.45428 16.965 7.4541 16.1367C7.4541 15.3083 8.06524 14.6367 8.81836 14.6367H24.0908ZM29.5459 7C30.2988 7.00027 30.9092 7.67174 30.9092 8.5C30.9092 9.32826 30.2988 9.99973 29.5459 10H3.36328C2.61033 9.99979 2 9.3283 2 8.5C2 7.6717 2.61033 7.00021 3.36328 7H29.5459Z"
      fill="currentColor"
    />
  </svg>
));

LocationsIcon.displayName = 'LocationsIcon';
